import { render, staticRenderFns } from "./view-token.vue?vue&type=template&id=404ce7a0&scoped=true"
import script from "./view-token.vue?vue&type=script&lang=js"
export * from "./view-token.vue?vue&type=script&lang=js"
import style0 from "./view-token.vue?vue&type=style&index=0&id=404ce7a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404ce7a0",
  null
  
)

export default component.exports